import * as React from "react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { BRAND_BUTTON_CLASS } from "@/components/common/brandTokens";

/**
 * CTA pill de marca FIVI360.
 *
 * Envolve o Button shadcn existente para preservar o merge atual
 * (base + variant default + size default + classes de marca).
 * Não altera o variant `default` do Button.
 *
 * button nativo, link interno e link externo via `asChild` (mesmo
 * padrão já usado na Home). Sem href/to mágicos.
 */
export const BrandButton = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <Button
        ref={ref}
        className={cn(BRAND_BUTTON_CLASS, className)}
        {...props}
      />
    );
  },
);

BrandButton.displayName = "BrandButton";
